import { Row } from '@tanstack/react-table';
import { ToDoRowModel } from '../entities/Entities';
import { Konflikt } from '../entities/Konflikt';
import { ArbeitsbereichFilter } from '@/domain/arbeitszeiten/DataTable';

export function sortArbeitsbereich(
  rowA: Row<ToDoRowModel>,
  rowB: Row<ToDoRowModel>,
): number {
  let arbeitsbreichA = '';
  let arbeitsbreichB = '';

  if (rowA.original instanceof Konflikt) {
    arbeitsbreichA =
      rowA.original.rootArbeitszeit.arbeitsbereich.name +
      rowA.original.rootArbeitszeit.arbeitsbereich.id;
  } else {
    arbeitsbreichA =
      rowA.original.arbeitsbereich.name + rowA.original.arbeitsbereich.id;
  }

  if (rowB.original instanceof Konflikt) {
    arbeitsbreichB =
      rowB.original.rootArbeitszeit.arbeitsbereich.name +
      rowB.original.rootArbeitszeit.arbeitsbereich.id;
  } else {
    arbeitsbreichB =
      rowB.original.arbeitsbereich.name + rowB.original.arbeitsbereich.id;
  }

  return arbeitsbreichA.localeCompare(arbeitsbreichB);
}

// eslint-disable-next-line complexity
export function filterArbeitsbereich(
  row: Row<ToDoRowModel>,
  _: string,
  filterValue: ArbeitsbereichFilter,
): boolean {
  if (!filterValue) {
    return true;
  }
  if (row.original instanceof Konflikt) {
    const konflikt = row.original;
    if (filterValue.arbeitsbereiche && filterValue.arbeitsbereiche.length > 0) {
      const arbeitsbereichId = konflikt.rootArbeitszeit.arbeitsbereich.id;
      return filterValue.arbeitsbereiche.includes(arbeitsbereichId);
    }
    if (filterValue.abteilungen && filterValue.abteilungen.length > 0) {
      const abteilungen = filterValue.abteilungen;
      return (konflikt.rootArbeitszeit.arbeitsbereich.abteilungen ?? []).some(
        (abteilung) => abteilungen.includes(abteilung.id),
      );
    }
    return true;
  }

  if (filterValue.arbeitsbereiche && filterValue.arbeitsbereiche.length > 0) {
    return filterValue.arbeitsbereiche.includes(row.original.arbeitsbereich.id);
  }
  if (filterValue.abteilungen && filterValue.abteilungen.length > 0) {
    const abteilungen = filterValue.abteilungen;
    return (row.original.arbeitsbereich.abteilungen ?? []).some((abteilung) =>
      abteilungen.includes(abteilung.id),
    );
  }
  return true;
}
